var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIconSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "in",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v64h64V0H0z M17.86,56.58H7.51V23.25h10.35V56.58z M12.75,18.82c-3.37,0-6.05-2.68-6.05-6.06 c0-3.38,2.67-6.06,6.05-6.06c3.26,0,6.05,2.68,6.05,6.06C18.79,16.02,16.12,18.82,12.75,18.82z M56.7,56.58H46.35v-16.2 c0-3.85-0.12-8.86-5.35-8.86c-5.35,0-6.16,4.2-6.16,8.62V56.7H24.49V23.25h9.88v4.55h0.12c1.4-2.68,4.77-5.36,9.77-5.36 c10.47,0,12.44,6.88,12.44,15.85V56.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIconSquare);
export default __webpack_public_path__ + "static/media/LinkedIn-Icon-Square.6549de21e4eca2c4447774edaaeb4359.svg";
export { ForwardRef as ReactComponent };